export default __webpack_public_path__ + "1125926ec9811ec35214b3da05d2885d.otf";